import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";
import Status from "@/vuex/Status";
import CatchFetch from "@/assets/Cache/Fetch";
import Logger from "@/assets/Helper/Logger";

class Warehouse {
    get(warehouseId, shopId) {
        CatchFetch.cacheFirst(Config.getters.getOrderPlatformHost + '/order/api/warehouse/' + shopId + '/?whId=' + warehouseId)
            .then(json => {
                if (typeof json.setId == 'string' && json.setId != "") {
                    SetData.dispatch('setSetId', json.setId).catch((error) => {
                        Logger.error(error);
                    });
                    SetData.dispatch('setShowSetImage', true).catch((error) => {
                        Logger.error(error);
                    });
                }

                let itemnumbersStart = [];

                for (let i in json.items) {
                    SetData.dispatch('addItem', json.items[i].itemnumber).then(() => {
                        itemnumbersStart[i] = json.items[i].itemnumber;
                    }).catch((error) => {
                        Logger.error(error);
                    });
                }

                if (SetData.getters.getItemnumbersStart.length < 1) {
                    SetData.dispatch("setItemnumbersStart", itemnumbersStart);
                }

                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
            })
            .catch((error) => {
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
                Logger.error(error);
            });
    }

    getPlaces(setId) {
        Status.commit("setLoading", true);

        let warehousePlaces = CatchFetch.cacheFirst('/item/warehouse/' + setId + '/')
            .then(json => {
                Status.commit("setLoading", false);
                return json;
            })
            .catch((error) => {
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });

                Logger.error(error);

                return {
                    'places' : [],
                    'status' : false
                };
            });
        return warehousePlaces;
    }
}

export default new Warehouse();